export default {
  messageThreadInputSendAMessage: 'Send a message',
  messageThreadInputLeaveAMessage: 'Leave a message',
  submitButtonAriaLabel: 'Submit',
};
